<template>
	<div v-if="manufacturers">
		<div>
			<div v-for="(manufacturer, index) in manufacturers" :key="index" class="flex tr">
				<div class="flex w-full space-x-4">
					<BaseCheckbox v-model="manufacturer.checked" v-if="!isManufacturerTypeAll" />
					<BaseInput
						:ref="'BaseInput.unchecked_wmi.' + index"
						:placeholder="$t('wmi')"
						v-model="manufacturer.wmi"
						class="w-1/6"
						mask="BBB"
						@input="manufacturer.checked = true"
						:required="true"
						:error-message="$t('required_value')"
					/>
					<BaseInput
						:ref="'BaseInput.unchecked_name.' + index"
						:placeholder="$t('name')"
						v-model="manufacturer.name"
						class="w-full"
						mask="CXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"
						@input="manufacturer.checked = true"
						:required="true"
						:error-message="$t('required_value')"
					/>
					<div class="ml-4 flex items-center justify-center h-12 w-12 flex-shrink-0">
						<button @click="deleteManufacturer(index, manufacturer)" :title="$t('delete_manufacturer')">
							<font-awesome-icon :icon="['fas', 'trash']" class="text-2xl"></font-awesome-icon>
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="text-center flex justify-end mt-4 space-x-4 mr-12 pr-4">
			<BaseButton @click="selectAll" v-if="!isManufacturerTypeAll">{{ $t('choose_all') }}</BaseButton>
			<BaseButton @click="deselectAll" v-if="!isManufacturerTypeAll">{{ $t('remove_all') }}</BaseButton>
			<BaseButton @click="save" class="btn-blue" tabindex="10000">{{
				isManufacturerTypeAll ? $t('general.save') : $t('copy_to_total_list')
			}}</BaseButton>
		</div>
	</div>
</template>
<script>
import BaseButton from '@/components/forms/buttons/BaseButton';
import BaseInput from '@/components/forms/inputs/BaseInput';
import BaseCheckbox from '@/components/forms/inputs/BaseCheckbox';
import Validate from '@/mixins/Validate';
import VehicleModelRepository from '@/api/repositories/VehicleModelRepository';

export default {
	name: 'VehicleManufacturerForm',
	components: { BaseCheckbox, BaseButton, BaseInput },
	mixins: [Validate],
	props: {
		manufacturers: {},
		isManufacturerTypeAll: { required: true },
	},
	methods: {
		deselectAll() {
			this.manufacturers.forEach(manufacturer => {
				this.$set(manufacturer, 'checked', false);
			});
		},
		selectAll() {
			this.manufacturers.forEach(manufacturer => {
				this.$set(manufacturer, 'checked', true);
			});
		},
		save() {
			if (!this.validate()) {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				return;
			}

			const checked = this.isManufacturerTypeAll ? this.manufacturers : this.manufacturers.filter(manufacturer => manufacturer.checked);

			if (checked.length > 0) {
				this.$emit('save', checked);
			} else {
				this.$swal(
					this.$t('general.attention').toString(),
					this.$t('please_choose_at_least_one', { variable: 'einen Hersteller' }).toString(),
					'warning',
				);
			}
		},
		deleteManufacturer(index, manufacturer) {
			this.$swal({
				title: this.$t('sure').toString(),
				text: this.$t('delete_manufacturer_prompt').toString(),
				icon: 'warning',
				confirmButtonText: this.$t('general.yes').toString(),
				cancelButtonText: this.$t('general.no').toString(),
				showCancelButton: true,
			}).then(result => {
				if (result.value) {
					VehicleModelRepository.index({ searchValue: manufacturer.wmi }).then(response => {
						if (response.data.data.length > 0) {
							this.$swal(this.$t('general.attention').toString(), this.$t('delete_vehicle_model_first').toString(), 'warning');
						} else {
							this.$emit('delete', manufacturer.id);
							this.manufacturers.splice(index, 1);
						}
					});
				}
			});
		},
	},
};
</script>
